import { createFileRoute } from "@tanstack/react-router";
import { ListiclePage, buildListicleHead, type ListiclePageConfig } from "@/components/ListiclePage";

const CONFIG: ListiclePageConfig = {
  slug: "top-colorado-google-business-profile-examples",
  metaTitle: "Top Colorado Google Business Profile Examples (And What to Steal) | Colorado Web Impressions",
  metaDescription: "Most Colorado small business owners under-use Google Business Profile. These examples show what a fully-leveraged GBP looks like — and exactly what to copy",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Insights", to: "/learn" },
  ],
  currentLabel: "GBP Examples — Colorado",
  eyebrow: "GBP Examples — Colorado",
  h1: <>{"Top Colorado Google Business Profile Examples (And What to Steal)"}</>,
  heroDescription: "Most Colorado small business owners under-use Google Business Profile.",
  intro: "Most Colorado small business owners under-use Google Business Profile. These examples show what a fully-leveraged GBP looks like — and exactly what to copy.",
  methodology: ["Based on real Colorado small business audits and projects", "Ranked by revenue impact, not opinion", "Patterns are repeatable — no proprietary tools required", "Updated quarterly as Colorado SERPs shift"],
  items: [
    {
      rank: 1,
      name: "Weekly Google Posts with real photos",
      whatWeLike: ["Updates 1–2x per week with real jobsite/team photos outperform monthly stock posts 3:1 on engagement."],
    },
    {
      rank: 2,
      name: "Product/service catalog fully populated",
      whatWeLike: ["Every service listed with pricing or starting-from anchor. Missed by 80% of competitors."],
    },
    {
      rank: 3,
      name: "Q&A seeded with real customer questions",
      whatWeLike: ["Owner-answered Q&A builds trust and ranks for long-tail queries inside the Map Pack."],
    },
    {
      rank: 4,
      name: "Booking link directly in the GBP",
      whatWeLike: ["Reservation/quote link reduces friction by one full step. Massive conversion lift."],
    },
    {
      rank: 5,
      name: "Photos geotagged and updated monthly",
      whatWeLike: ["Recency matters. Stale photo galleries get downranked vs active competitors."],
    },
    {
      rank: 6,
      name: "Review reply within 24 hours, always",
      whatWeLike: ["Response rate is a ranking signal. Reply to every review — positive and negative."],
    },
    {
      rank: 7,
      name: "Service-area cities listed accurately",
      whatWeLike: ["Don't keyword-stuff. List the cities you actually serve, with real coverage."],
    },
    {
      rank: 8,
      name: "Holiday hours updated every quarter",
      whatWeLike: ["Out-of-date hours kill trust. Auto-reminder calendar invite to update quarterly."],
    }
  ],
  closing: "Spend two hours this week applying these patterns to your GBP. It's the single best free lever you have for Map Pack rankings.",
  relatedLinks: [
    { to: "/local-seo", label: "local seo" },
    { to: "/colorado-springs-google-maps", label: "colorado springs google maps" }
  ],
};

export const Route = createFileRoute("/top-colorado-google-business-profile-examples")({
  head: () => buildListicleHead(CONFIG),
  component: () => <ListiclePage config={CONFIG} />,
});
